import * as React from 'react';
export const konbiniSvg = React.forwardRef(function konbiniSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      null,
      /*#__PURE__*/ React.createElement('path', {
        d: 'M4.867 6a2.227 2.227 0 0 1 1.16-1.867c.546-.4.72-.533.72-.88s-.174-.586-.494-.586-.533.24-.586.573h-.814A1.333 1.333 0 0 1 6.253 2c1 0 1.334.6 1.334 1.187s-.227.813-.92 1.36c-.48.333-.667.56-.734.733h1.814L7.64 6zm5.026 0v-.88H8.12v-.747L9.747 2.08h.92v2.347h.466v.693h-.466V6zm0-2.267v-.92a17.107 17.107 0 0 1-1.04 1.614H9.88z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M12 1.333v5.334H4V1.333zM12 0H4a1.333 1.333 0 0 0-1.333 1.333v5.334A1.333 1.333 0 0 0 4 8h8a1.333 1.333 0 0 0 1.333-1.333V1.333A1.333 1.333 0 0 0 12 0zm-1.333 10.667v4H5.333v-4zm0-1.334H5.333A1.333 1.333 0 0 0 4 10.667v4A1.333 1.333 0 0 0 5.333 16h5.334A1.333 1.333 0 0 0 12 14.667v-4a1.333 1.333 0 0 0-1.333-1.334z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.333 10h1.334v5.187H7.333zm-6.24-4.667H3.8V8H1.093zm0-2.666h2.52v1.36h-2.52zm11.32 0h2.52v1.36h-2.52zm-.28 2.666h2.987V8h-2.987z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M14.667 1.333H12v1.334h2.667v12H1.333v-12H4V1.333H1.333A1.333 1.333 0 0 0 0 2.667v12A1.333 1.333 0 0 0 1.333 16h13.334A1.333 1.333 0 0 0 16 14.667v-12a1.333 1.333 0 0 0-1.333-1.334z',
      }),
    ),
  );
});
konbiniSvg.defaultProps = {
  viewBox: '0 0 16 16',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var konbini = {
  category: 'paymentmethod',
  colorable: true,
  name: 'konbini',
  svg: konbiniSvg,
};
